import { useEffect, useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LanguageContext";

export default function VerifyEmailBanner() {
  const { user, setUser } = useAuth();
  const { t } = useLang();
  const [sending, setSending] = useState(false);
  const [shopClosed, setShopClosed] = useState(false);

  useEffect(() => {
    // la bannière « boutique fermée » occupe le haut : on se décale sous elle
    api.get("/settings/shop").then((r) => setShopClosed(r.data?.shop_open === false)).catch(() => {});
  }, []);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setSending(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      if (data.already) {
        setUser({ ...user, email_verified: true });
        toast.success(t("confirm.success_title"));
        return;
      }
      toast.success(t("verify.resent"));
    } catch {
      toast.error(t("verify.resend_error"));
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {/* Espaceur dans le flux : la bannière fixe ne recouvre pas le contenu */}
      <div className={shopClosed ? "h-24 md:h-20" : "h-16 md:h-12"} aria-hidden="true" />
      <div data-testid="verify-email-banner"
        className={`fixed ${shopClosed ? "top-28 md:top-32" : "top-16 md:top-20"} inset-x-0 z-40 bg-champagne/95 text-ink shadow-lg`}>
        <div className="max-w-7xl mx-auto px-6 py-3 flex flex-wrap items-center justify-center gap-3 text-sm">
          <MailWarning className="w-4 h-4 shrink-0" />
          <p className="text-center">{t("verify.banner")}</p>
          <button
            data-testid="verify-email-resend"
            onClick={resend}
            disabled={sending}
            className="inline-flex items-center gap-2 font-semibold underline underline-offset-2 hover:opacity-80 transition-opacity disabled:opacity-60"
          >
            {sending && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
            {t("verify.resend")}
          </button>
        </div>
      </div>
    </>
  );
}
